import Vue from 'vue';
Vue.component('review-item', {
    props: ['review'],
    data: function () {
        return {
            showMore: true,
        }
    },
    methods: {
        showMoreEvent: function () {
            this.showMore = !this.showMore
        }
    },
    template: '<div class="text-block" :class="[review.text.length > 200 && showMore == true  ? \'see-more\':\'\' ]">' +
                '<span class="name"><span class="fa fa-user"></span>{{review.user.name}}</span>' +
                ' <span class="org">{{review.user.org}}</span>' +
                ' <span class="time">{{review.created.formatted}}</span>' +
                ' <div class="text-comment"><p>{{review.text}}</p></div>' +
                '<div class="more-block" v-if="review.text.length > 200 && showMore">' +
                    '<button class="btn text-btn" @click="showMoreEvent()">Подробнее <i class="fa fa-angle-down right-icon"></i></button>' +
                '</div>' +
    '</div>'
});
if(document.getElementById('reviews-block')) {
var reviews_block = new Vue({
    el:'#course-landing',
    data:{
        reviews: [],
        showMore: false,
        pageCount: 0,
        page: 1,
        course_id: course_id,
        selectError:false,
        selected:0,
        currentPage: 1
    },
    mounted:function () {
        var self  = this;

        $('.select-filter').on('select2:select', function () {

            self.selected = parseInt(this.value)
            if( self.selected > 0){
                self.selectError = false;
            }


        });

    },
    computed: {
        paymentLink:function(){

            return '/courses/payment?id='+this.selected;

        }
    },

    methods:{
        payCourse:function(){

            if(this.selected > 0){

                document.location.href = this.paymentLink;

            } else{

                this.selectError = true;

            }

        },
        getReviews: function () {
            var self = this;
            this.load = true;
            try {
                $.ajax({
                    url: '/api/v1/review',
                    dataType: "json",
                    data: {
                        course_main_id: self.course_id,
                        page: self.page,
                    },
                    success: function (data) {

                            data.items.forEach(function (entry) {
                                self.reviews.push(entry);
                            });


                            //self.reviews = data;


                            self.pageCount = data._meta.pageCount;
                            self.currentPage = data._meta.currentPage
                        },
                        fail: function () {
                            throw new Error('Ошибка получении данных');
                        }
                    });

                } catch (e) {

                    console.error(e);


                }
            },
            nextPage: function () {
                this.page = this.page + 1;
            },
        },
        created: function () {
            this.getReviews();
        }
    })
}
